import { AdminApiError } from './api-client.js';

export const adminQueryDefaults = {
  queries: {
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    retry(failureCount: number, error: unknown) {
      if (failureCount >= 2) return false;
      return !(error instanceof AdminApiError) || error.kind === 'unavailable';
    },
  },
  mutations: {
    retry: false,
  },
} as const;
